(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('StatusAlumnoPlanDeEstudiosDetailController', StatusAlumnoPlanDeEstudiosDetailController);

    StatusAlumnoPlanDeEstudiosDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'StatusAlumnoPlanDeEstudios'];

    function StatusAlumnoPlanDeEstudiosDetailController($scope, $rootScope, $stateParams, previousState, entity, StatusAlumnoPlanDeEstudios) {
        var vm = this;

        vm.statusAlumnoPlanDeEstudios = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('serviciosocialApp:statusAlumnoPlanDeEstudiosUpdate', function(event, result) {
            vm.statusAlumnoPlanDeEstudios = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
